/**
 * «Ставки групп» у Экономиста — средние ставки маш.-часа групп механизаторов
 * по объектам и по умолчанию для холдинга (ТЗ AI-Economist-2026 ред. 2.1,
 * п. 6.3.2–6.3.3, 7.3). Читать — право чтения Экономиста, задавать ставки —
 * право записи; плашку «только чтение» показывает шапка раздела.
 */
import { useEconPermission } from '@entities/economic/types';
import { GroupRates } from '@widgets/GroupRates';

export function GroupRatesView() {
  const { can_write } = useEconPermission();
  return <GroupRates canWrite={can_write} />;
}
